import { motion, AnimatePresence } from "framer-motion";
import { X, Gift, Scissors } from "lucide-react";
import { useState, useEffect } from "react";

export default function CouponPopup() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const wasDismissed = sessionStorage.getItem("coupon_seen");
    if (wasDismissed) return;
    const timer = setTimeout(() => setVisible(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    setVisible(false);
    sessionStorage.setItem("coupon_seen", "1");
  };

  return (
    <AnimatePresence>
      {visible && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={dismiss}
            className="fixed inset-0 z-[60] bg-black/50 backdrop-blur-sm"
          />

          {/* Popup */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 30 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 30 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            data-testid="coupon-popup"
            className="fixed inset-0 z-[61] flex items-center justify-center p-4"
          >
            <div className="relative bg-white w-full max-w-sm shadow-[0_30px_80px_rgba(0,0,0,0.2)] overflow-hidden">
              {/* Top accent */}
              <div className="h-1 gold-bg" />

              {/* Close */}
              <button
                onClick={dismiss}
                data-testid="coupon-popup-close"
                className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-black transition-colors z-10"
              >
                <X size={18} />
              </button>

              {/* Coupon cutouts */}
              <div className="absolute -left-3 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-black/50 backdrop-blur-sm" />
              <div className="absolute -right-3 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-black/50 backdrop-blur-sm" />

              <div className="p-6 pt-8 text-center">
                {/* Icon */}
                <div className="w-14 h-14 gold-bg rounded-full flex items-center justify-center mx-auto mb-4">
                  <Gift size={24} className="text-white" />
                </div>

                <p className="text-[10px] font-semibold uppercase tracking-[0.25em] gold-text mb-2">
                  Hoş Geldin Hediyesi
                </p>

                <div className="text-5xl font-bold tracking-tighter gold-text mb-1">
                  %25
                </div>
                <p className="text-xs text-black/50 uppercase tracking-wider mb-4">
                  İndirim
                </p>

                <h3 className="text-lg font-bold tracking-tight text-black mb-2">
                  İlk Randevunuza Özel
                </h3>
                <p className="text-xs text-black/50 mb-5">
                  Tüm hizmetlerimizde geçerli indirim fırsatı
                </p>

                {/* Code */}
                <div className="inline-flex items-center gap-3 bg-[#FAFAFA] border border-dashed border-[#B76E79]/30 px-5 py-2.5 mb-5">
                  <Scissors size={14} className="text-[#B76E79]" />
                  <div className="text-left">
                    <p className="text-[9px] text-black/40 uppercase tracking-widest">Kupon Kodu</p>
                    <p className="text-base font-bold tracking-[0.15em] text-black">PUREVIA25</p>
                  </div>
                </div>
              </div>

              {/* Dashed separator */}
              <div className="mx-6 border-t border-dashed border-gray-200" />

              {/* CTA */}
              <div className="p-5">
                <a
                  href="https://wa.me/905441199544?text=Merhaba%2C%20PUREVIA25%20koduyla%20ilk%20randevuma%20%2525%20indirim%20almak%20istiyorum."
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={dismiss}
                  data-testid="coupon-popup-cta"
                  className="flex items-center justify-center w-full bg-black text-white hover:bg-gray-900 transition-colors duration-300 py-3.5 uppercase tracking-widest text-xs font-semibold"
                >
                  Kuponu Kullan
                </a>
              </div>

              {/* Bottom accent */}
              <div className="h-1 gold-bg" />
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
